const fetchPictureMarkerOption = (markPictureOption, imgIdList) => {
  return markPictureOption.map((element, index) => {
    const option = {
      parentNode: element?.parentNode || null,
      pos: element?.pos || [0, 0, 0], // 定位点，世界坐标，三维向量
      visible: element?.visible || true, // 显示隐藏状态
      size: -1, // 整体尺寸，二维向量，-1表示不限制，自动大小
      nodeOffset: element.nodeOffset,
      imgId: imgIdList[index], // 图片
      imgSize: element.imgSize, // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
      text: '', // 文本
      fontSize: 14.0, // 字体大小
      breakWidth: -1, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
      contentPadding: [10, 10, 10, 10], // 文字相对标记的偏移量
      textColor: -1, // 文本颜色
      title: '', // 标题
      titleFontSize: 18.0, // 标题文字大小
      titleColor: 0xffffffff, // 标题颜色
      userData: null, // 用户数据，仅帮外部系统保存数据
    }
    if (element.LodRange && element.LodRange.length > 2) {
      option.minLod = element.LodRange[0]
      option.maxLod = element.LodRange[1]
    }
    if (option.parentNode) delete option.pos
    return option
  })
}
// 图片标签
const createByPicture = async (player, markPictureOption) => {
  if (!player || !player.Native) {
    // 加载失败
    return {
      status: false,
      message: 'player无效',
      data: [],
    }
  }
  if (!Array.isArray(markPictureOption)) {
    markPictureOption = [markPictureOption]
  }
  // 获取需要加载标签的列表
  const imgList = markPictureOption.map((element) => {
    return element.backgroundUrl
  })

  const imgIdList = await player.Native?.GisMarker.loadImages(imgList)
  // 批量加载标签
  const optionList = fetchPictureMarkerOption(markPictureOption, imgIdList)
  const optionsPtr = await player.Native?.GisMarker.batchCreate(optionList)
  const currentLoadMarkers = []
  currentLoadMarkers.push(
    ...optionsPtr.map((el, index) => {
      return {
        id: markPictureOption[index].id,
        pointer: el,
      }
    })
  )
  return {
    status: true,
    message: '加载成功',
    data: currentLoadMarkers,
  }
}
/**
 * @description: 点选定位的功能方法(适合模型树的)
 * @param {*} player
 * @param {*} data 模型树点击的对象
 * @return {*}
 */
const multipleLocations = async (player, data, isSelect = true) => {
  // 高亮选中的模型
  if (isSelect) {
    player.Native.ModelTree.setSelectItemNoEvent(data.item)
  }
  // 计算获取到模型树item的aabb
  const result = await PlayerUtils.call(player.Native.ModelTree.calcItemAabbData, data.item)
  // 判断是否打开地球
  const isGis = await PlayerUtils.call(player.Native.GisPlatform.isGisMode)
  if (!isGis) {
    // 如果未打开地球，则用常规定位方式
    const aabbtmp = [result.aabb[0], result.aabb[1]]
    player.Native.Camera.moveToAabbWithFace(aabbtmp, 2, 0)
  } else {
    // 打开地球，需要考虑到模型的地形攀爬，防止摄像机定位过去之后位置在地面以下
    let bFind = false // 是否查找到具有gisTransform的祖先item
    let isChild = false // 当前点击的item是否是具有gisTransform item的子
    let toAabb = [] // 将要用来做最终定位的aabb
    let fItem = data.item // while 向上查询的临时变量
    while (fItem !== 0) {
      const iteminfos = await PlayerUtils.call(player.Native.ModelTree.getItemInfo, fItem)
      // gisTransform属性只能从节点对象中获取，因此，如果这里节点对象为0，则表明该item肯定不含有gisTransform
      if (!iteminfos.nodePtr || iteminfos.nodePtr === 0) {
        fItem = iteminfos.parentItem
        isChild = true
        continue
      }
      const nodeGisPos = await PlayerUtils.call(
        player.Native.NodeProxy.nodeGisPos,
        iteminfos.nodePtr
      )
      // 获取加载模型时设置的gisPos(即个isTransform信息)，如果该pos为空数组，表示当前item不含有gisTransform属性
      if (!nodeGisPos.length) {
        fItem = iteminfos.parentItem
        isChild = true
        continue
      }
      // 获取到了gisPos， 用gisPos中的经纬度查询实际高程
      const realH = await PlayerUtils.call(player.Native.GisPlatform.queryDEM, [
        [nodeGisPos[0], nodeGisPos[1]],
      ])
      // 使用查询到的高程与gisPos组成经纬高构造 gisTransform矩阵
      const realGisTransform = await player.Native.GisPlatform.makeGisTransform([
        nodeGisPos[0],
        nodeGisPos[1],
        realH[0],
      ])
      // 使用 gisTransform矩阵变换 模型对象的localAabb，从而得到实际需要定位的aabb
      toAabb[0] = result.localAabb[0]
      toAabb[1] = result.localAabb[1]

      toAabb = await player.Native.Camera.transformAabb(toAabb, realGisTransform)
      bFind = true
      break
    }
    // 这里判断相机朝向是否需要改变，通过from和to两个位置的up向量的夹角大于一定门限来判断
    let faceIndex = 1
    const camCurParam = await player.Native.Camera.currentParam()
    let v0 = camCurParam.eye
    let v1 = Vec3.multiplyScalar(Vec3.add(result.aabb[0], result.aabb[1]), 0.5)
    v0 = Vec3.normalize(v0)
    v1 = Vec3.normalize(v1)
    const angle = Vec3.angleBetween(v0, v1)
    // 如果夹角小于 1.5° ，则摄像机不用改变视角，只需要平移到目标包围盒
    if (angle < 1.5) {
      faceIndex = 0
    }
    // 执行定位
    if (bFind) {
      player.Native.Camera.moveToAabbWithFace(toAabb, 2, faceIndex)
    } else {
      const aabbtmp = [result.aabb[0], result.aabb[1]]
      player.Native.Camera.moveToAabbWithFace(aabbtmp, 2, faceIndex)
    }
  }
}
export { createByPicture, multipleLocations }
